package com.zaurh.mapquizwebsite.data.repository

import com.zaurh.mapquiz.data.response.SignInDO
import com.zaurh.mapquizwebsite.data.service.AuthApi
import com.zaurh.mapquizwebsite.domain.model.request.SignInRequest
import com.zaurh.mapquizwebsite.domain.repository.AuthRepository
import com.zaurh.mapquizwebsite.utils.Result
import com.zaurh.mapquizwebsite.utils.safeApiCall

class AuthRepositoryImpl(
    private val api: AuthApi
) : AuthRepository {
    override suspend fun signIn(username: String): Result<SignInDO> {
        return safeApiCall { api.signIn(SignInRequest(username = username)) }
    }
}